import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { EAPDatashareService } from 'src/app/services/eap/eap-datashare.service';
import { EapAllRequestsViewModalComponent } from './eap-all-requests-view-modal/eap-all-requests-view-modal.component';
import { EapReturnRetrivalModalComponent } from './eap-return-retrival-modal/eap-return-retrival-modal.component';
@Component({
  selector: 'app-eap-all-requests',
  templateUrl: './eap-all-requests.component.html',
  styleUrls: ['./eap-all-requests.component.scss']
})
export class EapAllRequestsComponent implements OnInit {
  columnDefs;
  operations;
  tempoperations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  ApplicationID: string;
  productlist: any = [];
  statuslist: any = [];
  AllRequestSearch: UntypedFormGroup;
  permission: string = "";
  isFundBasedApp: string = "";
  userType: string = "";
  IsPatientsAvailable = "yes";
  typeOptions = [];
  AppStatus: any;
  staticformFields: any;
  isProductBasedApp: string = "";
  collapesedOrNot: boolean = false;
  screenName: string = '';
  constructor(
    public route: ActivatedRoute,
    private summaryService: IstSummaryService,
    private modalService: NgbModal,
    private datashareService: EAPDatashareService,
    private commonService: CommonService,
    private userService: UserService,
  ) {
  }

  ngOnInit() {
    this.columnDefs = [
      {
        "headerName": "Product",
        "field": "ProductName"
      },
      {
        "headerName": "Requested",
        "field": "Requested"
      },
      {
        "headerName": "Allocated",
        "field": "Allocated"
      },
      {
        "headerName": "Used",
        "field": "Used"
      },
      {
        "headerName": "Status",
        "field": "StatusStr"
      }
    ];
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    this.getStaticFiledsData('SCR-019');
    this.GetScreenConfigControls('SCR-019');
    this.permission = this.commonService.getPagePermission("EAP06").toLowerCase();
    if (this.permission == null || this.permission == undefined || this.permission == '') {
      const intervalId = setInterval(() => {
        this.permission = this.commonService.getPagePermission("EAP06").toLowerCase();
        if (this.permission != null && this.permission != undefined && this.permission != '') {
            this.getSummary();
          clearInterval(intervalId);
        }
      }, 1000);
    }
    else {
      this.getSummary();
    }
    this.AppStatus = this.commonService.getEAPStatus();
    this.userType = this.userService.getUserType();
    this.AllRequestSearch = new UntypedFormGroup({
      RequestID: new UntypedFormControl(null),
      ProductName: new UntypedFormControl(null),
      RequestType: new UntypedFormControl(null),
      Status: new UntypedFormControl(""),
    });

    this.productlist = [];

    this.statuslist = [
      { "value": "0", "label": "All" },
      { "value": "1", "label": "Draft" },
      { "value": "2", "label": "Submitted" },
      { "value": "3", "label": "Approved" },
      { "value": "4", "label": "Rejected" },
      { "value": "5", "label": "Allocated" },
      { "value": "8", "label": "Withdrawn" },
      { "value": "7", "label": "Closed" },
      { "value": "10", "label": "Return Requested" }
    ];
    this.tempoperations = [

    ];
    this.advanceSearch = {
    };
    this.getMasterData();

  }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
    this.gridApi.sizeColumnsToFit();
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    let modalRef = this['self'].modalService.open(EapAllRequestsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'View',
      content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
    }
  }

  add_product_request() {
    let modalRef = this.modalService.open(EapAllRequestsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content = {
      heading: 'Add',
      content: { id: "", ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this.getSummary();
    })
    
  }

  edit(Record: any) {
    let modalRef = this['self'].modalService.open(EapAllRequestsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content = {
      heading: 'Edit',
      content: { id: Record['ID'], ApplicationID: this.ApplicationID }
    }
    modalRef.result.then(result => {
      this['self'].getSummary();
    })
  }

  getMasterData() {
    this.summaryService.getSummaryData("api/EAPAllRequests/GetSummaryMaster?ApplicationID=" + this.ApplicationID).subscribe(summary => {
      this.productlist = summary["MasterData1"];
      this.productlist = [{ label: "All", value: null, checked: true }].concat(this.productlist);
      if (summary["MasterData2"] != null && summary["MasterData2"] != undefined) {

     //   this.isFundBasedApp = summary["MasterData2"][1].value;
        this.isProductBasedApp = summary["MasterData2"][0].value;
      }

      if (summary["MasterData3"] != null && summary["MasterData3"] != undefined) {
        this.IsPatientsAvailable = summary["MasterData3"][0].value;
      }

    });
  }

  getSummary() {
    this.SearchClear();
    this.summaryService.getSummaryData("api/EAPAllRequests/getSummaryData?ApplicationID=" + this.ApplicationID).subscribe(summary => {

      this.rowData = this.setOperations(summary);
    });
  }

  setOperations(RawData: any): any {

    this.setDef(this.tempoperations);
    RawData.forEach(element => {

      if (element.StatusStr == "Submitted" && this.userType == "I") {
        let tempoperations2 = [
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Approve",
            "id": "approve"
          },
          {
            "name": "Reject",
            "id": "reject"
          }
        ];

        element["Operations"] = this.setDef(tempoperations2);
      }

      if (element.StatusStr == "Approved" && this.userType == "I") {
        let tempoperations2
        tempoperations2 = [
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Allocate",
            "id": "allocate"
          }
        ];

        element["Operations"] = this.setDef(tempoperations2);
      }

      if ((element.StatusStr == "Allocated" || element.StatusStr == "Return Requested") && this.userType == "I") {
        let tempoperations2 = [];

        if (element.Used != null && element.Used != undefined && element.Used != "" && (element.RetrivalQuantity == null || element.RetrivalQuantity == "" || element.RetrivalQuantity == undefined)) {
          tempoperations2.push(
            {
              "name": "View",
              "id": "view"
            },
            {
              "name": "Retrieve",
              "id": "retrieve"
            }
          );
        }

        if ((element.Used == null || element.Used == undefined || element.Used == "") && element.StatusStr == "Allocated") {
          tempoperations2.push({
            "name": "View",
            "id": "view"
          });

          element["Operations"] = this.setDef(tempoperations2);
        }

        if ((element.StatusStr == "Return Requested" || element.StatusStr == "Allocated") && element.RetrivalQuantity != null && element.RetrivalQuantity != "" && element.RetrivalQuantity != undefined) {
          tempoperations2.push({
            "name": "View",
            "id": "view"
          });
        }

        element["Operations"] = this.setDef(tempoperations2);
      }

      if (element.StatusStr == "Returned" && this.userType == "I") {
        if ((element.returnFund != null && element.returnFund != "")) {
          let tempoperations2 = [
            {
              "name": "View",
              "id": "view"
            },
            {
              "name": "Close",
              "id": "close"
            }
          ];

          element["Operations"] = this.setDef(tempoperations2);
        }
      }

      if (element.StatusStr == "Draft" && this.userType == "E") {
        if (this.permission == "new" || this.permission == "edit") {
          this.tempoperations = [
            {
              "name": "Edit",
              "id": "edit"
            },
            {
              "name": "View",
              "id": "view"
            },
            {
              "name": "Delete",
              "id": "delete"
            }

          ];

          if (this.AppStatus) {
            this.tempoperations.push(
              {
                "name": "Submit",
                "id": "submit"
              }
            )
          }

        }

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (element.StatusStr == "Submitted" && this.userType == "E") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Withdraw",
            "id": "withdraw"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if ((element.StatusStr == "Approved" || element.StatusStr == "Allocated") && this.userType == "E") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];


        if ((element.Used == null || element.Used == "" || element.Used == undefined) && element.StatusStr == "Allocated") {
          this.tempoperations.push(
            {
              "name": "Edit",
              "id": "edit"
            },
            {
              "name": "Withdraw",
              "id": "withdraw"
            },
            {
              "name": "Request Return",
              "id": "requestReturn"
            }
          );
        }

        if (element.StatusStr == "Approved") {
          this.tempoperations.push(
            {
              "name": "Withdraw",
              "id": "withdraw"
            }
          );
        }

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (element.StatusStr == "Return Requested" && this.userType == "E") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (element.StatusStr == "Returned" && this.userType == "E") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Withdraw",
            "id": "withdraw"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (element.RetrivalQuantity != null && element.RetrivalQuantity != "" && element.RetrivalQuantity != undefined && (element.StatusStr == "Allocated" || element.StatusStr == "Return Requested") && this.userType == "E") {
       
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          },
          {
            "name": "Return",
            "id": "returnrequest"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (element.StatusStr == "Closed" || element.StatusStr == "Withdrawn" || element.StatusStr == "Rejected") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }

      if (element.Allocated != null && element.Allocated != "" && element.Allocated != undefined &&
        element.Used != null && element.Used != "" && element.Used != undefined) {
        if (element.Allocated == element.Used && this.userType == "I" && element.StatusStr != "Closed") {
          let tempoperations2 = [
            {
              "name": "View",
              "id": "view"
            },
            {
              "name": "Close",
              "id": "close"
            }
          ];

          element["Operations"] = this.setDef(tempoperations2);
        }
      }

      if (this.permission == "view") {
        this.tempoperations = [
          {
            "name": "View",
            "id": "view"
          }
        ];

        element["Operations"] = this.setDef(this.tempoperations);
      }

    });

    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
    }, 500);
    return RawData;
  }

  setDef(parmoperations: any): any {
    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }

  setSummarySearch(searchObject) {
    this.summaryService.fetchSearchData("api/EAPAllRequests/getSummarySearchData", searchObject).subscribe(summary => {
      this.rowData = summary;
    });
  }


  view(Record: any) {
    let modalRef = this['self'].modalService.open(EapAllRequestsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true,
    });
    modalRef.componentInstance.Content = {
      heading: 'View',
      content: {
        id: Record['ID'],
        ReturnAmount: Record['WithOutSymbolUsed'] == null ? Record['WithOutSymbolAllocated'] : Record['WithOutSymbolAllocated'] - Record['WithOutSymbolUsed'],
        RetrieveVia: Record['RetrieveType'],
        UsedFund: Record['Used'],
        ReturnFund: Record['returnFund']
      }
    }
  }

  delete(Record: any) {
    if (Record['Status'] < 2) {
      let id = Record['ID'];
      let Type = Record['RequestType'];
      let modalRef = this["self"].modalService.open(DeleteBoxComponent, { backdrop: false });
      modalRef.componentInstance.Content = { heading: 'Delete', custommessage: 'Are you sure you want to delete ?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" };
      modalRef.result.then(result => {
        if (result == "okclick") {
          this['self'].summaryService.DeleteRecord('api/EAPAllRequests/Delete?RecordID=' + id).subscribe(summary => {
            if (summary["Status"] == 0) {
              // this['self'].toastrService.success("Selected Record(s) has been Deleted.");
              this['self'].commonService.SuccessBanner(this['self'].screenName + " deleted successfully")
              this['self'].getSummary();
            }
            else {
              this.commonService.ErrorBanner("Error Occurred while Deleting the record.Please try again after sometime.");
            }
          });
        }
      });
    }
    else {
      this.commonService.ValidationBanner("The submitted request cannot be deleted");
    }
  }

  approve(Record: any) {
    if (Record['Status'] == 2) {
      this['self'].summaryService.getSummaryData("api/EAPAllRequests/Approve?RecordID=" + Record["ID"]).subscribe(summary => {
        this['self'].commonService.SuccessBanner(this['self'].screenName + " has been approved");
        this['self'].getSummary();
      })
    }
    else {
      this['self'].commonService.ValidationBanner("Selected operation is not Possible for current Record");
    }

  }

  submit(Record: any) {
    if (Record['Status'] < 2) {
      this['self'].summaryService.getSummaryData("api/EAPAllRequests/Submit?RecordID=" + Record["ID"]).subscribe(summary => {

        this['self'].commonService.SuccessBanner(this["self"].screenName + " has been Submitted")
        this['self'].getSummary();
      })
    }
    else {
      this.commonService.ValidationBanner("Selected operation is not Possible for current Record");
    }
  }

  reject(Record: any) {
    if (Record['Status'] == 2) {

      this['self'].summaryService.getSummaryData("api/EAPAllRequests/Reject?RecordID=" + Record["ID"]).subscribe(summary => {
        this['self'].commonService.SuccessBanner(this['self'].screenName + " has been rejected");
        this['self'].getSummary();
      });
    }
    else {
      this['self'].commonService.ValidationBanner("Selected operation is not Possible for current Record");
    }

  }

  requestReturn(Record: any) {
    let modalRef = this["self"].modalService.open(DeleteBoxComponent, { backdrop: false });
    if (Record['RequestType'] == "Product") {
      modalRef.componentInstance.Content = { header: 'Confirmation', custommessage: 'Do you want to return the product?', ProceedButtonName: "Yes", TerminateButtonName: "No" };
    } else {
      modalRef.componentInstance.Content = { header: 'Confirmation', custommessage: 'Do you want to return the fund?', ProceedButtonName: "Yes", TerminateButtonName: "No" };
    }
    modalRef.result.then(result => {
      if (result == "okclick") {
        this['self'].summaryService.getSummaryData("api/EAPAllRequests/RequestReturn?RecordID=" + Record["ID"]).subscribe(summary => {
          this['self'].commonService.SuccessBanner("Return request submitted successfully");
          this['self'].getSummary();
        });
      }
    });
  }

  close(Record: any) {
    if (Record['Status'] > 3) {
      const modalRef = this["self"].modalService.open(DeleteBoxComponent, { backdrop: false });
      modalRef.componentInstance.Content = { header: 'Close', custommessage: 'You are about to close the request. Do you want to proceed?', ProceedButtonName: "Yes", TerminateButtonName: "Cancel" };
      modalRef.result.then(result => {
        if (result == "okclick") {
          this['self'].summaryService.getSummaryData("api/EAPAllRequests/Close?RecordID=" + Record["ID"]).subscribe(summary => {
            if (summary != null && summary.Message == "N") {
              if (Record['RequestType'] == "Product") {
                this.commonService.ValidationBanner("Selected operation is not Possible Please Adjust Product ");
              }
              else {
                this.commonService.ValidationBanner("Selected operation is not Possible Please Adjust Fund");
              }
            }
            else {
              this['self'].commonService.SuccessBanner(this['self'].screenName + " has been closed");
              this['self'].getSummary();
            }

          });
        }
      });
    }
    else {
      this.commonService.ValidationBanner("Selected operation is not Possible for current Record");
    }

  }

  allocate(Record: any) {
    if (Record['Status'] == 3) {
      if (Record["Allocated"] != null && Record["Allocated"] != "" && Record["Allocated"] != undefined) {
        this['self'].summaryService.getSummaryData("api/EAPAllRequests/Allocate?RecordID=" + Record["ID"]).subscribe(summary => {
          this['self'].commonService.SuccessBanner(this['self'].screenName + " updated successfully");
          this['self'].getSummary();
        });
      }
      else {
        let modalRef = this['self'].modalService.open(EapAllRequestsViewModalComponent, {
          backdrop: false,
          keyboard: false,
          windowClass: 'modal-vlg right modal-right',
          animation: true,
        });
        modalRef.componentInstance.Content = {
          heading: 'Allocate',
          content: { id: Record['ID'], ApplicationID: this.ApplicationID, AllocatedAmount: Record["Allocated"] }
        }
        modalRef.result.then(result => {
          this['self'].getSummary();
        });
      }


    }
    else {
      this.commonService.ValidationBanner("Selected operation is not Possible for current Record");
    }
  }

  returnrequest(Record: any) {
    if (Record['Status'] == 5 || Record['Status'] == 10) {
      if (Record["returnFund"] != null && Record["returnFund"] != "" && Record["returnFund"] != undefined) {
        this.commonService.SuccessBanner("Return details shared successfully");
        this['self'].getSummary();
      }
      else {
        let modalRef = this['self'].modalService.open(EapAllRequestsViewModalComponent, {
          backdrop: false,
          keyboard: false,
          windowClass: 'modal-vlg right modal-right',
          animation: true,
        });
        modalRef.componentInstance.Content = {
          heading: 'Return',
          content: {
            id: Record['ID'], ApplicationID: this.ApplicationID,
            ReturnAmount: Record['WithOutSymbolUsed'] == null ? Record['WithOutSymbolAllocated'] : Record['WithOutSymbolAllocated'] - Record['WithOutSymbolUsed'],
            RetrieveVia: Record['RetrieveType']
          }
        }
        modalRef.result.then(result => {
          if (result.Status == 0) {
            this['self'].getSummary();
          }
        })
      }
    }
    else {
      this.commonService.ValidationBanner("Selected operation is not Possible for current Record");
    }
  }

  retrieve(Record: any) {
    if (Record['Status'] == 5 || Record['Status'] == 10) {
      let modalRef = this['self'].modalService.open(EapReturnRetrivalModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-md right modal-right',
        animation: true,
      });
      modalRef.componentInstance.Content = {
        heading: null,
        content: {
          id: Record['ID'],
          ApplicationID: this.ApplicationID,
          Allocated: Record["Allocated"],
          ProductUnits: Record["ProductUnits"],
         ReturnAmount: Record['WithOutSymbolUsed'] == null ? Record['WithOutSymbolAllocated'] : Record['WithOutSymbolAllocated'] - Record['WithOutSymbolUsed'],
        }
      }
      modalRef.result.then(result => {
        this['self'].getSummary();
      })
    }
    else {
      this.commonService.ValidationBanner("Selected operation is not Possible for current Record");
    }
  }

  withdraw(Record: any) {
    if (Record['Status'] == 5 || Record['Status'] == 6) {
      if (Record['RequestType'] == "Product") {
        this['self'].commonService.ValidationBanner("To withdraw the request please raise return request for the allocated Product");
      } else {
        this['self'].commonService.ValidationBanner("To withdraw the request please raise return request for the allocated Fund");
      }
    } else {
      this['self'].summaryService.getSummaryData("api/EAPAllRequests/WithDraw?RecordID=" + Record["ID"]).subscribe(summary => {
        this['self'].commonService.SuccessBanner("The request has been withdrawn Successfully");
        this['self'].getSummary();
      });
    }
  }
  SearchClear() {
    this.AllRequestSearch?.reset();
  }

  AdvanceSearch() {
    var formData = this.AllRequestSearch.value;
    formData["ApplicationID"] = this.ApplicationID;
    if (formData["Status"] != "" && formData["Status"] != undefined && formData["Status"] != null) {
      formData["Status"] = parseInt(formData["Status"]);
    }
    else{
      formData["Status"]=null;
    }
    this.setSummarySearch(formData);
  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, '', (ScreenData) => {
      this.screenName = ScreenData.NAME;
    });
  }
}
